import * as React from 'react'
import { styled } from '@design/pt-ui'

import Option, { IOption } from './Option'

const Container = styled('div')({
  display: 'flex',
  flexWrap: 'wrap',
  flexDirection: 'row',
  borderRadius: 8,
  alignItems: 'center',
  width: '420px',
})

const isSelected = <T extends {}>(value: T, selected: T[]) => {
  return selected.findIndex((s) => s === value) !== -1
}

interface IOptionGridProps<T> {
  multiple: boolean
  error: boolean
  disabled?: boolean
  disabledOptionTooltip?: string
  selected: Array<T>
  options: Array<IOption<T>>
  onChange: (value: any) => void
}

function OptionGrid<T extends {}>(props: IOptionGridProps<T>) {
  const handleOnClick = (value: T) => {
    if (props.disabled) {
      return
    }

    if (props.options.findIndex((o) => o.value === value) === -1) {
      // User selected option that isn't listed in options list?
      return
    }

    const isValueSelected = props.selected.findIndex((s) => s === value) === -1
    if (isValueSelected) {
      if (props.multiple) {
        props.onChange([...props.selected, value])
      } else {
        props.onChange([value])
      }
    } else {
      props.onChange(props.selected.filter((s) => s !== value))
    }
  }

  return (
    <Container>
      {props.options.map((option) => {
        return (
          <Option
            {...option}
            error={props.error}
            key={`${option.value}`}
            selected={isSelected(option.value, props.selected)}
            disabled={option.disabled || props.disabled || false}
            tooltip={option.disabled ? props.disabledOptionTooltip : undefined}
            onClick={handleOnClick as any}
          />
        )
      })}
    </Container>
  )
}

export default OptionGrid
